export enum StorageKeys {
  MobileHelpScreenShown = 'mobile-help-screen-shown',
  TableAgeType = 'table-age-type',
}
